var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "drag-and-drop",
    class: _vm.answerPosition
  }, [_c('div', {
    staticClass: "label-stage",
    class: _vm.answerPosition
  }, [_c('ul', {
    staticClass: "drop-zone",
    class: _vm.answerPosition
  }, [_c('img', {
    staticClass: "drag-and-drop-image",
    attrs: {
      "src": _vm.imagePath
    }
  }), _vm._l(_vm.steps, function (step, index) {
    return _c('li', {
      key: index,
      staticClass: "drop-destination",
      style: _vm.getDropDestinationBoxStyling(step.x, step.y),
      attrs: {
        "correct-answers": step.correctAnswers.join(',')
      }
    }, [_c('label-box', {
      attrs: {
        "white": "",
        "height": _vm.labelHeight,
        "width": _vm.getLabelWidth(),
        "label": ""
      }
    })], 1);
  })], 2), _c('ul', {
    staticClass: "drag-zone",
    class: _vm.answerPosition
  }, _vm._l(_vm.labels, function (label) {
    return _c('li', {
      key: label,
      staticClass: "drag-target"
    }, [_c('label-box', {
      attrs: {
        "label": label,
        "height": _vm.labelHeight,
        "width": _vm.getLabelWidth()
      }
    })], 1);
  }), 0)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }